<template>
  <div :class="classes">
    pt-adult-sell-order-form
    <input type="text" data-vv-as="demo字段" v-validate="'required'" placeholder="tip" />
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-adult-sell-order-form'

export default {
  name: 'pt-adult-sell-order-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      formValue: {

      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
